import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("rect", {
      x: "6.5",
      y: "6",
      stroke: "currentColor",
      rx: ".5"
    }, null, -1),
    r("path", {
      stroke: "currentColor",
      d: "M4 6h16m-9.5 2.5v9m3-9v9M9.5 4l-1 2h7.155L14.5 4z"
    }, null, -1)
  ])]);
}
const m = { render: l };
export {
  m as default,
  l as render
};
